import { init, getCurrentScope, browserTracingIntegration, addBreadcrumb } from '@sentry/vue';
import { transactionPatternIntegration } from './transaction-pattern-integration';

if (process.env.NODE_ENV === 'production') {
  const isStand = window.APP_VERSION.split('-').length > 1;
  const [standName] = location.host.split('.');

  if (window.SENTRY_DSN) {
    window.Sentry = {
      init(app, options) {
        init({
          sampleRate: 0.8,
          maxBreadcrumbs: 10,
          app,
          attachProps: true,
          dsn: window.SENTRY_DSN,
          environment: isStand ? 'stand' : 'prod',
          release: window.APP_VERSION,
          tracesSampleRate: isStand ? 0 : 0.5,
          integrations: [
            // Отключили, т.к. сильно загаживает
            // ToDo: https://huntflow.atlassian.net/browse/DEV-14244
            // new CaptureConsole({
            //   levels: ['error']
            // }),
            transactionPatternIntegration(),
            browserTracingIntegration({
              router: options.router
            })
          ],
          beforeSend: (event) => {
            const route = options.router
              ? options.router.currentRoute.value
              : options.route;

            const attributes: Record<string, unknown> = {};

            const params = route.params || {};
            for (const key of Object.keys(params)) {
              attributes[`params.${key}`] = params[key];
            }
            const query = route.query || {};
            for (const key of Object.keys(query)) {
              const value = query[key];
              if (value) {
                attributes[`query.${key}`] = value;
              }
            }

            return {
              ...event,
              extra: {
                ...event.extra,
                'vue.route': attributes
              },
              tags: {
                ...event.tags,
                routeName: route.name,
                url: window.location.href // по-дефолту в url не попадает хэш, когда переведём на роутинг без хэша - дропнуть
              }
            };
          },
          initialScope: (scope) => {
            if (isStand) {
              scope.setTag('stand_name', standName);
            }
            scope.setTag('host', window.location.host);
            return scope;
          },
          beforeBreadcrumb(breadcrumb, hint) {
            if (breadcrumb.category === 'xhr' && hint) {
              const { xhr, input } = hint as {
                xhr: XMLHttpRequest;
                input: string | null;
              };

              addBreadcrumb({
                type: 'query',
                category: 'xhr payload',
                level: 'info',
                message: `${breadcrumb.data?.url} payload`,
                data: {
                  // hint.init.headers доступен только в Fetch API, и не доступен в Axios.
                  // Axios использует XmlHttpRequest, из которого невозможно достать заголовки запроса.
                  // Поэтому requestId будет устанавливаться только для запросов,
                  // сделанных через Fetch API (или библиотеку ky).
                  requestId: new Headers(hint.init?.headers).get('X-Request-Id'),
                  request: input && String(input).slice(0, 1000),
                  response:
                    breadcrumb.data?.status_code >= 500
                      ? undefined
                      : String(xhr.response).slice(0, 1000)
                }
              });
            }
            return breadcrumb;
          }
        });

        const scope = getCurrentScope();
        const account = options.account;
        if (account) {
          scope.setUser({
            id: String(account.id),
            name: account.name,
            email: account.email
          });
          scope.setTag('organization', options.organization);
        }
      }
    };
  }
}
